import { ColumnViewModel } from '../../shared/column-types';

export const GDA_ALL_SUMMARY: ColumnViewModel = {
  columns: [
    'geneSymbol',
    'geneDescription',
    'geneNcbiID',
    'diseaseName',
    'diseaseUMLSCUI',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numberNCTSWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'EL',
    'geneDSI',
    'geneDPI',
    'genepLI',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'disease_prevalence_class',
    'disease_prevalence_type',
    'disease_prevalence_geo_area',
    'disease_inheritance',
    'geneEnsemblIDs',
    'geneNcbiType',
    'geneProteinStrIDs',
    'geneProteinClassNames',
    'pathwayName',
    'pathwayID',
    'numCTs',
    'chemPrefName',
    'chemID',
  ],
  defaultVisible: [
    'geneSymbol',
    'geneDescription',
    'diseaseName',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'EL',
    'geneDSI',
    'geneDPI',
    'genepLI',
    'diseaseType',
    'diseaseClassName_MSH',
    'numCTs',
  ],
};